module.exports = __webpack_public_path__ + "d8bef0e6c9051e156a17a4dbc7933cbf.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/alert_camera.png
// module id = 15
// module chunks = 0